import { render, staticRenderFns } from "./StartseiteTor.vue?vue&type=template&id=52bc8dca"
import script from "./StartseiteTor.vue?vue&type=script&lang=js"
export * from "./StartseiteTor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports